var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 186,
    viewBox: "0 0 149 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.427 38.0668V146.589C148.427 150.328 146.326 153.752 142.992 155.452L86.2401 184.377C86.2401 184.377 86.2251 184.382 86.2201 184.387L84.5808 185.219L83.3777 184.687L4.87891 150.037V32.006L62.1025 1.91791C64.4937 0.659644 67.311 0.499228 69.8275 1.47677L142.777 29.8153C144.667 30.5523 146.201 31.8907 147.193 33.5601C147.985 34.8935 148.427 36.4476 148.427 38.0668Z",
    fill: "#68708E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.428 38.0668V146.589C148.428 150.328 146.327 153.752 142.994 155.452L86.2414 184.377C86.2414 184.377 86.2264 184.382 86.2214 184.387C85.71 184.723 85.1586 185.003 84.5821 185.219C84.1961 185.369 83.7951 185.484 83.384 185.57V184.687L82.6621 69.2327L88.2015 66.1697L147.195 33.5601C147.987 34.8935 148.428 36.4476 148.428 38.0668Z",
    fill: "#141930"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9302 72.0952V177.514C89.9302 180.462 88.4263 182.933 86.2407 184.377C86.2306 184.382 86.2256 184.382 86.2206 184.387C85.7093 184.723 85.1579 185.003 84.5814 185.219C84.1954 185.369 83.7943 185.485 83.3832 185.57C81.8192 185.901 80.1298 185.775 78.4956 185.084L4.07233 153.527C1.72122 152.529 0.197266 150.228 0.197266 147.676V38.3676C0.197266 35.3398 2.25761 32.9536 4.87942 32.2317C6.1427 31.8858 7.53632 31.9259 8.88983 32.4623L82.9672 61.8436C85.1729 62.7209 86.9826 64.2548 88.2008 66.1698C89.3036 67.9043 89.9302 69.9446 89.9302 72.0952Z",
    fill: "#4A516B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7168 143.796V45.6212C7.7168 44.2677 9.08034 43.3453 10.3386 43.8416L78.1396 70.7364C78.9066 71.0422 79.4029 71.7741 79.4029 72.5963V172.596C79.4029 174.591 77.3676 175.94 75.5279 175.163L10.123 147.431C8.66426 146.814 7.7168 145.38 7.7168 143.796Z",
    fill: "#404459"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M142.065 67.7935V145.164C142.065 147.41 140.842 149.476 138.872 150.558L102.217 170.641C101.575 170.991 100.878 171.167 100.181 171.167C99.4394 171.167 98.6924 170.966 98.0257 170.57C96.7223 169.798 95.9453 168.435 95.9453 166.926V92.3773C95.9453 89.4046 97.5795 86.7026 100.216 85.329L138.22 65.4625C139.042 65.0313 140.005 65.0614 140.797 65.5427C141.594 66.0239 142.065 66.8661 142.065 67.7935Z",
    fill: "url(#paint0_linear_89_30666)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140.797 65.5427C140.005 65.0614 139.042 65.0313 138.22 65.4625L100.216 85.329C97.5795 86.7026 95.9453 89.4046 95.9453 92.3773V166.926C95.9453 168.435 96.7223 169.798 98.0257 170.57C98.6924 170.966 99.4394 171.167 100.181 171.167C100.878 171.167 101.575 170.991 102.217 170.641L138.872 150.558C140.842 149.476 142.065 147.41 142.065 145.164V67.7935C142.065 66.8661 141.594 66.0239 140.797 65.5427ZM140.06 145.164C140.06 146.678 139.233 148.072 137.909 148.799L101.254 168.881C100.557 169.267 99.7301 169.252 99.0434 168.846C98.3616 168.44 97.9505 167.723 97.9505 166.926V92.3773C97.9505 90.1566 99.1737 88.1363 101.144 87.1037L139.147 67.2371C139.428 67.0917 139.669 67.202 139.759 67.2571C139.849 67.3123 140.06 67.4727 140.06 67.7935V145.164Z",
    fill: "url(#paint1_linear_89_30666)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_30666)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_89_30666",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 74,
    width: 38,
    height: 71
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23 74.8447L61 89.6168L60.9762 144.845L23 128.981V74.8447Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_89_30666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9822 127.538C60.9822 137.101 55.4119 142.528 48.5887 139.676L23 128.982L24.544 122.499L43.7014 130.431C48.6956 132.502 52.7693 128.682 52.7693 121.895C52.7693 118.463 51.7361 114.949 50.0555 112.045C48.4224 109.205 46.1777 106.958 43.7014 105.967C42.2702 105.392 35.5954 102.688 31.8601 101.18C30.4408 100.605 29.3007 98.5458 29.3007 96.5746C29.3007 94.6035 30.4527 93.4536 31.8661 94.0168L50.3049 101.338L52.1577 93.4243L33.511 86.1028L35.0728 79.5381L45.8095 83.7151C49.6992 85.2287 53.1019 89.4761 54.8597 94.4861C55.6792 96.8093 56.1424 99.2967 56.1424 101.743C56.1424 102.289 56.1186 102.811 56.077 103.321C55.8633 105.744 55.1566 107.774 54.0936 109.276C58.1733 113.74 60.9822 120.751 60.9762 127.544L60.9822 127.538Z",
    fill: "#FF385C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.661 119.12C45.661 121.109 44.4911 122.247 43.0599 121.66L26.7471 114.978L28.1664 108.419L43.0599 114.462C44.497 115.043 45.661 117.131 45.661 119.12Z",
    fill: "#FF385C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_89_30666",
    x1: 99.3893,
    y1: 118.149,
    x2: 138.872,
    y2: 118.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272B43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_89_30666",
    x1: 118.84,
    y1: 78.3208,
    x2: 119.176,
    y2: 157.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A516B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2034"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_30666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 70,
    fill: "white",
    transform: "translate(23 74.8447)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/BOX.67f3dc5fbe10a61d15766b518a29d63f.svg";
export { ForwardRef as ReactComponent };